import Vue from 'vue';
import Router from 'vue-router';
import ExpressPay from '@/components/ExpressPay';
import FindYourBill from '@/components/FindYourBill';
import PaymentInfo from '@/components/PaymentInfo';
import ProcessingPayment from '@/components/ProcessingPayment';
import Review from '@/components/Review';
import Confirmation from '@/components/Confirmation';
import ErrorPage from '@/components/ErrorPage';
import Maintenance from '@/components/Maintenance';
import RedirectPage from '@/components/RedirectPage';

Vue.use(Router);

let approute = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: ExpressPay,
      children: [
        {
          path: '/',
          redirect: 'find-your-bill'
        },
        {
          path: '/find-your-bill',
          name: 'find-your-bill',
          component: FindYourBill
        },
        {
          path: '/payment-info',
          name: 'payment-info',
          component: PaymentInfo
        },
        {
          path: '/processing-payment',
          name: 'processing-payment',
          component: ProcessingPayment
        },
        {
          path: '/review',
          name: 'review',
          component: Review
        },
        {
          path: '/confirmation',
          name: 'confirmation',
          component: Confirmation
        },
        {
          path: '/error',
          name: 'error',
          component: ErrorPage
        },
        {
          path: '/redirect',
          name: 'redirect',
          component: RedirectPage
        },
        {
          path: '/maintenance',
          name: 'maintenance',
          component: Maintenance
        },
        {
          path: '*',
          redirect: 'find-your-bill'
        }
      ]
    }
  ]
});

approute.onError(() => {
  approute.push({ name: 'error' });
});

export default approute;



// WEBPACK FOOTER //
// ./src/router/index.js